import React, { useState, useEffect } from "react";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import {
  Button,
  DropdownButton,
  Form,
  FormControl,
  FormLabel,
} from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import axios, { post, get, patch } from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import service from "../../../../services/service";
import Loader from "../../../../components/Loader";
import empty from "is-empty";
import Breadcrumbs from "../../../../components/Breadcrumbs";

import "../../.././common.css";

import CustomModal from "../../../../components/CustomModal";

const SiCollectionLogForm = () => {

  
  let navigate = useNavigate();
  let tokenKey = `Bearer ${sessionStorage.getItem("tokenkey")}`;


  let location = useLocation();

  let propsState = location.state;
  const [form, setForm] = useState({});
  const [editMode, setEditMode] = useState(
    (propsState && propsState.editMode) || false
  );
  const [errors, setErrors] = useState({});
  const [loading, setloading] = useState(true);
  const [overlay, setoverlay] = useState(false);

  let toastAttr = {
    theme: "colored",
    position: "top-center",
    autoClose: 1000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };
  let breadcrumbData = [
    {
      title: "Dashboard",
      href: "/admin/dashboard",
    },
    {
      title: "SI Collection Log",
      href: "/admin/logs/sicollectionlog",
    },
    {
      title: editMode ? "View" : "Create",
      href: "#",
    },
  ];
  const [tab, setTab] = useState({
    details: true,
  });
  const [tabData, setTabData] = useState([
    {
      name: "API Log Details",
      id: "details",
      show: true,
    },
  ]);

  const [user, setUser] = useState([]);
  const [getcustomer, setGetCustomer] = useState([]);
  
  const handleInput = (keyName, value) => {
    console.log(keyName,value,"KJBVYGUVBI")
    setForm({
      ...form,
      [keyName]: value,
    });
    if (keyName && !!errors[keyName])
      setErrors({
        ...errors,
        [keyName]: null,
      });
  };

  const renderListView = () => {
    return navigate("/admin/masters/customer");
  };

  const findErrors = () => {
    const { scheme_id, scheme_name, country_id, min_amount, max_amount } = form;
    const newErrors = {};

    if (empty(scheme_id)) newErrors.scheme_id = "This is a required field";
    if (empty(scheme_name)) newErrors.scheme_name = "This is a required field";
    if (empty(country_id)) newErrors.country_id = "This is a required field";
    if (empty(min_amount)) newErrors.min_amount = "This is a required field";
    if (empty(max_amount)) newErrors.max_amount = "This is a required field";
    return newErrors;
  };

  // const saveForm = () => {
  //   let id = editMode ? propsState.id : null,
  //     method = editMode ? "put" : "post";
  //   console.log(editMode, "mode");
  //   const newErrors = findErrors();
  //   if (Object.keys(newErrors).length > 0) {
  //     setErrors(newErrors);
  //     toast.error("Enter all required details to proceed", toastAttr);
  //   } else {
  //     setLoader(true);
  //     let url = editMode
  //         ? service.scheme_create + form.id + "/update/"
  //         : service.scheme_create,
  //       data = JSON.parse(JSON.stringify(form));
  //     console.log("-----------");
  //     axios({
  //       url: url,
  //       method: method,
  //       headers: tokenKey,
  //       data: data,
  //     })
  //       .then((res) => {
  //         if (editMode) setForm(res.data);
  //         toast.success("Saved successfully", toastAttr);
  //         setLoader(false);
  //       })
  //       .catch((err) => {
  //         if (err.response.status === 401) window.location.href = "/";
  //         else toast.error("Area already exists", toastAttr);
  //         setLoader(false);
  //       });
  //   }
  // };

  const [show, setShow] = useState(false);
  const [Body, setBody] = useState("");

  const handleClose = (e) => {
    console.log(e, "from modal");
    setShow(e);
  };

  const setLoader = (val) => {
    setloading(val);
    setoverlay(val);
  };

  useEffect(() => {
    if (user.length == 0) {
      setLoader(true);

      axios({
        url: service.customer_list,
        method: "get",
        headers: { Authorization: tokenKey },
      })
        .then((res) => {
          setUser(res.data.results);
        setLoader(false);

        })
        .catch((err) => {
          setLoader(false);
  
          if (err?.response?.status === 401) {
            window.location.href = "/";
          }
          if (err?.response?.status === 500) {
            setShow(true)
            setBody(err.response.data)
          } else if (err?.response?.status === 400) {
            setShow(true)
            setBody(err.response.data.message)
          } else {
            setShow(true)
            setBody(err.response.data.message)
          }
        });
    }

    console.log(propsState);
    if (propsState && propsState.editMode) {
      setLoader(true);

      axios({
        url: service.sicollection_log+propsState.id+"/",
        method: "get",
        headers: { Authorization: tokenKey },
      })
        .then((res) => {
          setForm(res.data);
          console.log(res);
          setLoader(false);
          console.log(form);
        })
        .catch((err) => {
          setLoader(false);
  
          if (err?.response?.status === 401) {
            window.location.href = "/";
          }
          if (err?.response?.status === 500) {
            setShow(true)
            setBody(err.response.data)
          } else if (err?.response?.status === 400) {
            setShow(true)
            setBody(err.response.data.message)
          } else {
            setShow(true)
            setBody(err.response.data.message)
          }
        });
      }
  }, []);


  return (
    <Loader loading={loading} overlay={overlay}>

    <Container>
      <Row >
        <Col md={12}>
          <Card className="country__list">
            <CardBody className="ms-3">
            <Row className="d-flex justify-content-between">
                <Col md={4}>
                  <h3 className="pt-3 px-3 text-primary">SI Collection Log Details</h3>
                </Col>
                
                <Col md={4}>
                  <div className="pt-3">

            <Breadcrumbs data={breadcrumbData} />
                  </div>

                </Col>
                <Col md={4}>
                  
                </Col>
              </Row>
              <hr />
              <Row>
                <Col md={12}>
                  <div>
                    <Form>
                      
                        {tab.details ? (
                          <>
                            <Row className="py-3">
                              <Col md={6} className="d-grid gap-3">
                                <Row>
                                  <Col md={4}>
                                    <Form.Label className="mt-2">
                                      Card Number
                                    </Form.Label>
                                  </Col>
                                  <Col md={7}>
                                  <Form.Control
                                      readOnly
                                      type="text"
                                      name="card_number"
                                      className="input-border"
                                      value={form.card_number}
                                    />
                                  </Col>
                                </Row>
                                
                              </Col>

                              <Col md={6} className="d-grid gap-3">

                              <Row>
                                  <Col md={4}>
                                    <Form.Label className="mt-2">
                                      Customer Name
                                    </Form.Label>
                                  </Col>
                                  <Col md={7}>
                                  <Form.Control
                                      readOnly
                                      type="text"
                                      name="customer_name"
                                      className="input-border"
                                      value={form.customer_name}
                                    />
                                  </Col>
                                </Row>
                              </Col>

                            </Row>
                            
                            <Row className="py-3">
                              <Col md={6} className="d-grid gap-3">
                                <Row>
                                  <Col md={4}>
                                    <Form.Label className="mt-2">
                                      Customer ID
                                    </Form.Label>
                                  </Col>
                                  <Col md={7}>
                                    <Form.Control
                                      readOnly
                                      name="customer_id"
                                      className="input-border"
                                      value={form.customer_id}
                                    >
                                    </Form.Control>
                                  </Col>
                                </Row>
                              </Col>

                              <Col md={6} className="d-grid gap-3">
                                <Row>
                                  <Col md={4}>
                                    <Form.Label className="mt-2">
                                      Amount
                                    </Form.Label>
                                  </Col>
                                  <Col md={7}>
                                    <Form.Control
                                      readOnly
                                      type="text"
                                      name="amount"
                                      className="input-border"
                                      value={form.amount}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            <Row className="py-3">
                              <Col md={6} className="d-grid gap-3">
                                <Row>
                                  <Col md={4}>
                                    <Form.Label className="mt-2">
                                      Mobile
                                    </Form.Label>
                                  </Col>
                                  <Col md={7}>
                                    <Form.Control
                                      readOnly
                                      name="mobile_no"
                                      className="input-border"
                                      value={form.mobile_no}
                                    >
                                    </Form.Control>
                                  </Col>
                                </Row>
                              </Col>

                              <Col md={6} className="d-grid gap-3">
                                <Row>
                                  <Col md={4}>
                                    <Form.Label className="mt-2">
                                    EMI Month
                                    </Form.Label>
                                  </Col>
                                  <Col md={7}>
                                    <Form.Control
                                      readOnly
                                      type="text"
                                      name="emi_month"
                                      className="input-border"
                                      value={form.emi_month}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>


                            <Row className="py-3">
                              <Col md={6} className="d-grid gap-3">
                                <Row>
                                  <Col md={4}>
                                    <Form.Label className="mt-2">
                                      Country Name
                                    </Form.Label>
                                  </Col>
                                  <Col md={7}>
                                    <Form.Control
                                      readOnly
                                      name="country_name"
                                      className="input-border"
                                      value={form.country_name}
                                    >
                                    </Form.Control>
                                  </Col>
                                </Row>
                              </Col>

                              <Col md={6} className="d-grid gap-3">
                                <Row>
                                  <Col md={4}>
                                    <Form.Label className="mt-2">
                                    Country ID
                                    </Form.Label>
                                  </Col>
                                  <Col md={7}>
                                    <Form.Control
                                      readOnly
                                      type="text"
                                      name="customer_id"
                                      className="input-border"
                                      value={form.customer_id}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            <Row className="py-3">
                              <Col md={6} className="d-grid gap-3">
                                <Row>
                                  <Col md={4}>
                                    <Form.Label className="mt-2">
                                    Payment Gateway
                                    </Form.Label>
                                  </Col>
                                  <Col md={7}>
                                    <Form.Control
                                      readOnly
                                      name="payment_gateway"
                                      className="input-border"
                                      value={form.payment_gateway}
                                    >
                                    </Form.Control>
                                  </Col>
                                </Row>
                              </Col>

                              <Col md={6} className="d-grid gap-3">
                                <Row>
                                  <Col md={4}>
                                    <Form.Label className="mt-2">
                                    S2D Transaction ID
                                    </Form.Label>
                                  </Col>
                                  <Col md={7}>
                                    <Form.Control
                                      readOnly
                                      type="text"
                                      name="s2d_transaction_id"
                                      className="input-border"
                                      value={form.s2d_transaction_id}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            <Row className="py-3">
                              <Col md={6} className="d-grid gap-3">
                                <Row>
                                  <Col md={4}>
                                    <Form.Label className="mt-2">
                                    Checksum
                                    </Form.Label>
                                  </Col>
                                  <Col md={7}>
                                    <Form.Control
                                      readOnly
                                      name="checksum"
                                      className="input-border"
                                      value={form.checksum}
                                    >
                                    </Form.Control>
                                  </Col>
                                </Row>
                              </Col>

                              <Col md={6} className="d-grid gap-3">
                                <Row>
                                  <Col md={4}>
                                    <Form.Label className="mt-2">
                                    Equals Status
                                    </Form.Label>
                                  </Col>
                                  <Col md={7}>
                                    <Form.Control
                                      readOnly
                                      type="text"
                                      name="equals_status"
                                      className="input-border"
                                      value={form.equals_status}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>














                            {/* <Row className="py-3">
                              <Col md={6} className="d-grid gap-3">
                                <Row>
                                  <Col md={4}>
                                    <Form.Label className="mt-2">
                                      Created By
                                    </Form.Label>
                                  </Col>
                                  <Col md={7}>
                                  <Form.Select
                                      disabled
                                      name="created_by_id"
                                      className="input-border"
                                      value={form.created_by_id?.id}
                                      onChange={(e) =>
                                        handleInput(
                                          "created_by_id",
                                          e.target.value
                                        )
                                      }
                                      isInvalid={!!errors.created_by_id}
                                    >
                                        {user.map((user1) => (
                                          <option
                                            key={user1.id}
                                            value={user1.id}
                                            className="dropdown"
                                          >
                                            {user1.email}
                                          </option>
                                        ))}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.created_by_id}
                                    </Form.Control.Feedback>
                                  </Col>
                                </Row>
                              </Col>

                              <Col md={6} className="d-grid gap-3">
                                <Row>
                                  <Col md={4}>
                                    <Form.Label className="mt-2">
                                      Updated By
                                    </Form.Label>
                                  </Col>
                                  <Col md={7}>
                                  <Form.Select
                                      disabled
                                      name="updated_by_id"
                                      className="input-border"
                                      value={form.updated_by_id?.id}
                                      onChange={(e) =>
                                        handleInput(
                                          "updated_by_id",
                                          e.target.value
                                        )
                                      }
                                      isInvalid={!!errors.updated_by_id}
                                    >
                                        {user.map((user1) => (
                                          <option
                                            key={user1.id}
                                            value={user1.id}
                                            className="dropdown"
                                          >
                                            {user1.email}
                                          </option>
                                        ))}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.updated_by_id}
                                    </Form.Control.Feedback>
                                  </Col>
                                </Row>
                              </Col>
                            </Row> */}

                            <Row className="py-3">
                              <Col md={12} className="d-grid gap-3">
                                <Row>
                                  <Col md={2}>
                                    <Form.Label className="mt-2">
                                    Gateway Request Parameter
                                    </Form.Label>
                                  </Col>
                                  <Col md={10}>
                                    <Form.Control
                                      readOnly
                                      as="textarea"
                                      name="gateway_request_parameters"
                                      className="input-border"
                                      value={form.gateway_request_parameters}
                                      style={{height:'170px'}}
                                    >
                                    </Form.Control>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>


                            <Row className="py-3">

                              <Col md={12} className="d-grid gap-3">
                                <Row>
                                  <Col md={2}>
                                    <Form.Label className="mt-2">
                                    Gateway Response Parameter
                                    </Form.Label>
                                  </Col>
                                  <Col md={10}>
                                    <Form.Control
                                      readOnly
                                      as="textarea"
                                      name="gateway_response_parameters"
                                      className="input-border"
                                      value={form.gateway_response_parameters}
                                      style={{height:'170px'}}
                                    />

                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            <Row className="py-3">

                              <Col md={12} className="d-grid gap-3">
                                <Row>
                                  <Col md={2}>
                                    <Form.Label className="mt-2">
                                    Equals Request Parameter
                                    </Form.Label>
                                  </Col>
                                  <Col md={10}>
                                    <Form.Control
                                      readOnly
                                      as="textarea"
                                      name="equals_request_parameters"
                                      className="input-border"
                                      value={form.equals_request_parameters}
                                      style={{height:'170px'}}
                                    />

                                  </Col>
                                </Row>
                              </Col>
                            </Row>


                            <Row className="py-3">

                              <Col md={12} className="d-grid gap-3">
                                <Row>
                                  <Col md={2}>
                                    <Form.Label className="mt-2">
                                    Equals Response Parameter
                                    </Form.Label>
                                  </Col>
                                  <Col md={10}>
                                    <Form.Control
                                      readOnly
                                      as="textarea"
                                      name="equals_response_parameters"
                                      className="input-border"
                                      value={form.equals_response_parameters}
                                      style={{height:'170px'}}
                                    />

                                  </Col>
                                </Row>
                              </Col>
                            </Row>


                          </>
                        ) : (
                          ""
                        )}
                      <CustomModal show={show} body={Body} handleClose={handleClose} />
                    </Form>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
    </Loader>
  );
};

export default SiCollectionLogForm;
